var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_3004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4 10.6C17.0964 9.45514 15.5293 8.65117 13.839 8.25995C12.1487 7.86873 10.3878 7.90246 8.71375 8.35812C7.03967 8.81379 5.50459 9.67719 4.24575 10.8711C2.98691 12.0651 2.04355 13.5524 1.5 15.2L4 16C4.41429 14.7677 5.12265 13.655 6.06377 12.7581C7.00488 11.8612 8.15039 11.2072 9.40115 10.8527C10.6519 10.4981 11.9702 10.4537 13.242 10.7233C14.5138 10.993 15.7007 11.5684 16.7 12.4L13 16H22V7L18.4 10.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_3004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.1ae535c7ad7be25fe52b4c532c87c12e.svg";
export { ForwardRef as ReactComponent };